import React from 'react';
import SafePureComponent from "@manual_encounters/encounter_reconcile/pings/common/SafePureComponent";
import {formatDate} from "@manual_encounters/encounter_reconcile/pings/utils/dateFormatters";

class PingDateText extends SafePureComponent {
  safeRender() {
    return (
      <span className="ping-date-text" data-testid="ping-date-text">
        on {formatDate(this.props.date)}
      </span>
    );
  }
}

export default PingDateText;
